// Change this url to match your local machine's ip address
// It is used for the native apps
export default "http://localhost";
